import React, { useEffect, useState } from 'react'
import {
	useGetCandidateQuery,
	useGetVacancyQuery,
} from '../store/api/vacanciesApi'
import { useParams } from 'react-router-dom'
import {
	Box,
	Breadcrumbs,
	Button,
	Card,
	CardContent,
	Chip,
	Link,
	Skeleton,
	Typography,
} from '@mui/material'
import { useNavigate } from 'react-router'
import QuestionModal from '../components/QuestionModal'

const CandidatePage = () => {
	const params = useParams()
	const navigate = useNavigate()

	const [isOpenModal, setIsOpenModal] = useState(false)

	const { data: candidate, isLoading: isLoadingCandidate } =
		useGetCandidateQuery(params.candidateId)
	const {
		data: vacancy,
		isLoading: isLoadingVacancy,
		isError,
	} = useGetVacancyQuery(params.id)

	useEffect(() => {
		if (!isLoadingVacancy && isError) {
			navigate(`/vacancies/${params.id}`)
		}
	}, [isLoadingVacancy])

	return (
		<Box>
			<Breadcrumbs sx={{ mb: '16px' }} separator="›" aria-label="breadcrumb">
				<Link underline="hover" color="inherit"  onClick={() => navigate('/vacancies')}>
					Вакансії
				</Link>
				<Link
					underline="hover"
					color="inherit"
					onClick={() => navigate(`/vacancies/${params.id}`)}
				>
					{isLoadingVacancy || !vacancy ? (
						<Skeleton
							variant="text"
							sx={{ fontSize: '16px', width: '160px' }}
						/>
					) : (
						vacancy.title
					)}
				</Link>
				<Typography key="3" sx={{ color: 'text.primary' }}>
					{isLoadingCandidate || !candidate ? (
						<Skeleton
							variant="text"
							sx={{ fontSize: '16px', width: '160px' }}
						/>
					) : (
						candidate.first_name + ' ' + candidate.last_name
					)}
				</Typography>
			</Breadcrumbs>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				{isLoadingCandidate || !candidate ? (
					<Skeleton variant="rectangular" height={500} width={700} />
				) : (
					<Card sx={{ maxWidth: '700px', width: '100%' }}>
						<CardContent>
							<Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
								<Box>
									<Typography variant="h5" component="div">
										{candidate.first_name + ' ' + candidate.last_name}
									</Typography>
									<Typography color="text.secondary">
										{candidate.desired_position}
									</Typography>
								</Box>
								<Button onClick={() => setIsOpenModal(true)} sx={{ ml: '16px' }}>Задати питання</Button>
							</Box>
							{candidate.age && <Typography variant="body2">
								<strong>Вік:</strong> {candidate.age}
							</Typography>}
							{candidate.location && <Typography variant="body2">
								<strong>Локація:</strong> {candidate.location}
							</Typography>}
							{candidate.desired_salary && <Typography variant="body2">
								<strong>Бажана зарплата:</strong> {candidate.desired_salary} USD
							</Typography>}
							{candidate.schedule && <Typography variant="body2">
								<strong>Графік:</strong> {candidate.schedule}
							</Typography>}
							<Typography variant="body2">
								<strong>Умови роботи:</strong>{' '}
								{candidate.is_remote ? 'Віддалено' : 'Офіс'}
							</Typography>
							<Typography variant="body2">
								<strong>Мови:</strong>{' '}
								{candidate.languages ? JSON.parse(candidate.languages).join(', ') : 'Немає даних'}
							</Typography>
							<Typography variant="body2" sx={{ mt: 2 }}>
								<strong>Навички:</strong>
							</Typography>
							<Box
								sx={{
									display: 'flex',
									flexWrap: 'wrap',
									gap: '8px',
									mt: 1,
									maxWidth: '600px',
								}}
							>
								{candidate.skills.map((skill, index) => (
									<Chip key={index} label={skill} />
								))}
							</Box>
							{candidate.experience_text && <Typography variant="body2" sx={{mt: 2}}>
								<strong>Досвід:</strong> {candidate.experience_text}
							</Typography>}
						</CardContent>
					</Card>
				)}
			</Box>
			<QuestionModal
				isOpen={isOpenModal}
				onClose={() => setIsOpenModal(false)}
			/>
		</Box>
	)
}

export default CandidatePage
